import { Button, Grid, Typography } from '@material-ui/core';
import { useRouter } from 'next/router';
import React from 'react';
import { segmentEventApi } from '../../constants/analyticsMeta';
import { useView } from '../../utility/services/uiHelpers';
import UpgradeToolsPlan from './upgradeToolsPlan';

const PricingSection = ({ classes, handlePlanSelection, planPurchaseLoading }) => {
  const isMobile = useView('mobileOnly');
  const router = useRouter();
  const handleExploreFreeTools = () => {
    router.push('/free-tools/title-generator');
    if (window.analytics) {
      window.analytics.track(`Clicked Explore Free AI Tools`, {
        option: 'Explore Free AI Tools',
      });
    } else {
      segmentEventApi(
        `Clicked Explore Free AI Tools`,
        {
          option: 'Explore Free AI Tools',
        },
        'track'
      );
    }
  };
  const handleTermsOfUseClick = () => {
    if (window.analytics) {
      window.analytics.track(`Clicked Read Terms of Use`, {
        option: 'Read Terms of Use`',
      });
    } else {
      segmentEventApi(
        'Clicked Read Terms of Use',
        {
          option: 'Read Terms of Use`',
        },
        'track'
      );
    }
  };

  return (
    <Grid container className={classes.root}>
      <div className={classes.overallToolsWrapper}>
        <div className={classes.topHeadingsWrapper}>
          {!isMobile ? (
            <Typography variant="h1" className={classes.topHeading}>
              Unlock Success with Quick AI Tools{' '}
            </Typography>
          ) : (
            <Typography variant="h1" className={classes.topHeading}>
              Unlock Success with Quick AI Tools
            </Typography>
          )}
          {/* {!isMobile ? (
            <Typography className={classes.topSubHeadingForTools}>Maximum Value at a Minimal Cost.</Typography>
          ) : null} */}

          <Typography className={classes.topSubHeadingForTools}>
            The Go-to Resource for Fast, High Quality AI Content{' '}
          </Typography>
        </div>
      </div>
      <div>
        <div className="upgrade-tools-plan-wrapper">
          <UpgradeToolsPlan
            planPurchaseLoading={planPurchaseLoading}
            handlePlanSelection={handlePlanSelection}
            handleTermsOfUseClick={handleTermsOfUseClick}
          />
        </div>

        <div className="explore-tools-section">
          <Typography className="explore-section-heading">
            100K+ Users are Generating Content with Quick AI Tools{' '}
          </Typography>

          {/* <Typography className="orDivider">OR </Typography>
           */}
          <br />

          <Typography className="explore-section-heading-black">
            Explore What Quick AI Tools Can Do With Free Access
          </Typography>
          <Typography className="explore-section-description">
            Create your free account and start using our tools instantly. Use a corporate email to get 2X free credits
            every 8 hours. This waiting period ensures fair access for all users.{' '}
          </Typography>
          <Typography className="explore-section-terms">
            *Fair usage policy applies. Read{' '}
            <span
              className="terms-of-use"
              onClick={() => {
                handleTermsOfUseClick();
                window.open('/content-ai/terms', '_blank');
              }}
            >
              terms of use
            </span>{' '}
            for more.{' '}
          </Typography>
          <Button className="explore-free-ai-tools-btn" onClick={() => handleExploreFreeTools()}>
            Explore Free AI Tools
          </Button>
        </div>
      </div>
    </Grid>
  );
};

export default PricingSection;
